export default "__VITE_ASSET__JXL6Nury__"